import React, { PureComponent } from "react";
import { Button, Text, View,FlatList, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import styles from "./styles";

class SecondScreen extends PureComponent {
  render() {
    const { navigation } = this.props;
    return (
      <View style={styles.container}>
          <View style={{height: 60}}>
              <FlatList
                  //   inverted={true}
                  keyboardShouldPersistTaps="handled"

                  style={{
                      // height: 10,
                      marginVertical: 10,
                      alignSelf: 'center'
                  }}
                  //  data={data.results.all_categories}
                  data={[{id: 1, name: 'متوفی'}, {id: 2, name: 'شهید'}]}

                  renderItem={({item, index}) =>

                      <TouchableOpacity
                          onPress={() => {
                              // props.navigation.toggleRightDrawer()
// alert(useIsDrawerOpen())
//                                 if (useIsDrawerOpen())
//                                 this.props.navigation.openDrawer()
//                                 else
                              this.props.navigation.toggleDrawer()
                              this.setState({
                                  indexSelectType: index,
                                  type: item.id
                              })
                          }
                          }
                          style={{
                              paddingHorizontal: 3,
                              backgroundColor: "#e4b4ee",
                              //backgroundColor: Colors.gray,
                              borderRadius: 10,
                              marginHorizontal: 2,
                              alignItems: 'center',
                              justifyContent: 'center'
                          }}
                      >
                          <Text>{(item.name)}</Text>
                          {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                          {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                          {/*<HMTextView text={item.name} type={"bold"}*/}
                          {/*style={{*/}
                          {/*color: Colors.white,*/}
                          {/*marginHorizontal: moderateScale(6),*/}
                          {/*fontSize: moderateScale(13),*/}
                          {/*textAlign: 'center',*/}
                          {/*paddingHorizontal: moderateScale(4)*/}
                          {/*}}/>*/}


                      </TouchableOpacity>
                  }
                  horizontal={true}
                  showsHorizontalScrollIndicator={false}
                  keyExtractor={(item, index) => index.toString()}
                  inverted={true}
              />
          </View>
        <Text style={styles.welcome}>
          Hi! Second Screen reporting for duty!
        </Text>
        <Button
          title="User #1"
          onPress={() => navigation.navigate("User", { name: "Snufolafakus" })}
        />
        <Button
          title="User #2"
          onPress={() =>
            navigation.navigate("User", {
              name: "Simsalabimbambasaladusaladim"
            })
          }
        />
        <Button
          title="Das Modal"
          onPress={() => navigation.navigate("DasModal")}
        />
      </View>
    );
  }
}
export default SecondScreen;
/*const mapStateToProps = state => ({});

export default connect(
  mapStateToProps,
  {}
)(SecondScreen);*/
